// Bài hướng dẫn trang Bảng set chụp — /set-board.
//
// ⚠️ Ranh giới thông tin ở `../types.ts` áp NGUYÊN VẸN.

import type { GuideBook } from "../types";

export const SET_BOARD_GUIDES: GuideBook = {
  set_board: {
    purpose: "Nơi cả cơ sở biết set nào trống, set nào đang chụp, set nào cần dọn, và khách hay ekip đang ở đâu.",
    where: [
      'Ô "Chọn cơ sở" và ô ngày ở đầu trang. Chọn ngày cũ thì chỉ xem, không bấm được.',
      'Các nút cách xem: "Tòa nhà", "Theo tầng", "Theo khách". Điện thoại mở sẵn "Theo tầng", máy tính mở sẵn "Tòa nhà", đã chọn cách nào thì lần sau mở lại cách đó. Quản lý trực tiếp có thêm "Sắp xếp sơ đồ".',
      'Dải số "Lấp đầy" ngay dưới ô chọn ngày: "Lấp đầy theo lịch" (cùng con số thẻ Lấp đầy bên Marketing), "Set đã có khách thật" tính bằng giờ-set, và khi xem hôm nay thêm ô "Còn trống tới …h" — số giờ-set còn bán được, đã trừ giờ khách đặt trên lịch.',
      'Quản lý trực tiếp và ca trưởng thấy thêm khung đỏ "Đơn lệch set" và khung "Đã bổ sung" ngay dưới dải số. Không có đơn nào thì khung không hiện.',
      "Hàng số đầu trang đếm số set đang Trống, Đang chuẩn bị, Đang chụp, Chờ dọn.",
      'Cách xem "Tòa nhà": các tầng xếp chồng, set đang chụp có hình người của ekip và khách đang ở set đó: thợ chụp áo nâu vàng cầm máy ảnh, trang điểm áo xanh cầm cọ, khách đứng giữa — khách nữ mặc váy, khách nam mặc vest, đơn chưa ghi giới tính thì áo xám. Trên đầu ekip là ảnh đại diện kèm tên, trên đầu khách là chữ "Khách" kèm tên. Mỗi set vẽ tối đa 3 người ekip và 2 khách, còn lại gộp thành "+N người". Bấm set để xem đủ tên.',
      'Cách xem "Theo tầng": mỗi tầng một hàng, mỗi ô là một set. Dưới cùng là khối "Khách chưa vào set" có nút "Chọn set".',
      'Cách xem "Theo khách": giống sheet cũ, có ô tìm tên khách hoặc tên thợ.',
      'Ô "Góc ảnh thẻ" hiện số khách đang chụp và đang chờ, lấy từ bảng khách ảnh thẻ tại quầy.',
      'Bấm một ô set để xem khách, thợ chụp, trang điểm và các nút "Chụp xong", "Bắt đầu dọn", "Đã sẵn sàng", "Tạm đóng".',
      'Khi công ty bật phần gắn đồ với concept / set: hộp chi tiết set có thêm hai khối "Đồ dựng ở set này" và "Đồ concept cần" — mỗi concept của set một nhóm bấm mở / gập, nhóm đang thiếu mở sẵn, mỗi dòng ghi đồ ở đâu và "Có" / "Thiếu".',
    ],
    howItWorks: [
      "Khách và ekip tự lấy từ lịch trong ngày, không phải nhập lại.",
      "Thợ chọn set cho khách thì set sang Đang chụp. Đổi sang set khác thì set cũ tự sang Chờ dọn.",
      "Bấm \"Chụp xong\" chỉ trả set, không đổi trạng thái của đơn. Xong ca vẫn bấm ở màn Lịch ekip như cũ.",
      "Đơn chuyển sang bước sau hoặc bị hủy thì set tự sang Chờ dọn, kể cả khi quên bấm \"Chụp xong\".",
      "Chọn set đang có ekip khác hoặc chưa dọn xong: màn hỏi lại, xác nhận thì vẫn vào được.",
      "Bảng tự làm mới vài giây một lần, mọi máy cùng thấy.",
      "Góc ảnh thẻ tự cập nhật theo bảng khách ảnh thẻ tại quầy, thợ không phải bấm gì thêm và không có bước chờ dọn.",
      "Giờ-set chỉ tính trong giờ mở bán và chỉ tính set đang mở. Hai ekip dùng chung một set cùng lúc thì giờ đó chỉ tính một lần.",
      'Đơn chụp xong mà chưa chọn set lần nào, hoặc chọn ít set hơn số concept của đơn, sẽ hiện ở khung "Đơn lệch set" kèm từng concept còn thiếu. Đơn chuyển qua nhiều set hơn số concept là bình thường, không hiện.',
      'Bổ sung set xong thì đơn rời khung "Đơn lệch set" và nằm ở khung "Đã bổ sung". Lượt bổ sung chỉ ghi concept chụp ở set nào, không cộng vào giờ dùng set.',
      "Cuối ngày, cơ sở còn đơn lệch thì quản lý trực tiếp nhận một tin chuông, bấm tin là mở đúng bảng của ngày đó.",
      "Xoá, đổi số hay đổi tên set ở \"Sắp xếp sơ đồ\" không làm sai số ngày trước: mỗi lượt khách vào set đều ghi lại tên set lúc đó.",
      'Hai khối đồ đạc lấy số từ Kho: món dựng cố định ở set do quản lý / trưởng ca gắn ở mục Kho (hoặc thủ kho gắn bên Kho); đồ concept cần do người làm concept khai ở Concept & Trang phục → thẻ "Đồ đạc". Món đang dựng ở set khác vẫn tính là có, kèm chữ "đang dựng ở set …" để ekip biết mang sang.',
    ],
    statuses: [
      { label: "Trống", meaning: "Set sẵn sàng đón khách." },
      { label: "Đang chuẩn bị", meaning: "Support đang setup hoặc dọn set." },
      { label: "Đang chụp", meaning: "Có ekip đang dùng set. Bấm vào để xem khách và ekip." },
      { label: "Chờ dọn", meaning: "Vừa chụp xong, support cần dọn lại." },
      { label: "Tạm đóng", meaning: "Set đang hỏng hoặc đang sửa, không chọn được." },
      { label: "Chưa chọn set lần nào", meaning: "Đơn đã chụp xong nhưng không ai bấm chọn set cho khách." },
      { label: "Còn concept chưa có set", meaning: "Đơn có nhiều concept hơn số set đã chọn; khung ghi tên concept còn thiếu." },
      { label: "Chưa khai sức chứa đặt lịch", meaning: "Cơ sở chưa khai số chỗ và giờ mở bán nên chưa tính được lấp đầy theo lịch." },
    ],
    blocks: [
      {
        for: ["photo"],
        title: "Việc của thợ chụp",
        steps: [
          'Tới giờ chụp, mở "Theo tầng", tìm tên khách trong khối "Khách chưa vào set", bấm "Chọn set".',
          "Chọn set trống. Set hợp concept của khách nằm trên cùng, có nhãn \"Hợp concept\".",
          'Đổi sang set khác: bấm "Đổi set" ở cách xem "Theo khách" rồi chọn set mới.',
          'Chụp xong ở set này: bấm vào ô set, bấm "Chụp xong".',
        ],
        troubles: [
          "Bạn chọn set được cho mọi khách của cơ sở mình trong ngày, kể cả khách không có tên bạn trong ekip.",
          "Không thấy nút → bạn đang xem cơ sở khác cơ sở của mình, hoặc đang xem ngày khác hôm nay.",
          "Màn báo set đang có ekip khác → hỏi ekip đó, thật sự dùng chung thì bấm \"Vẫn vào\".",
        ],
      },
      {
        for: ["assistant"],
        title: "Việc của support",
        steps: [
          'Đưa khách vào set: mở "Theo tầng", tìm tên khách trong khối "Khách chưa vào set", bấm "Chọn set" rồi chọn set trống. Khách chụp xong thì bấm vào ô set, bấm "Chụp xong".',
          "Nhìn các ô màu vàng Chờ dọn để biết set cần xử lý.",
          'Bấm vào ô, bấm "Bắt đầu dọn". Ô sang Đang chuẩn bị để mọi người biết bạn đang làm.',
          'Xong thì bấm "Đã sẵn sàng". Ô về Trống.',
          'Muốn chuẩn bị trước cho set trống: bấm ô đó, bấm "Bắt đầu dọn".',
        ],
        troubles: ["Màn báo set vừa đổi trạng thái → người khác vừa bấm trước, chờ bảng tự làm mới."],
      },
      {
        for: ["makeup", "reception"],
        title: "Việc của trang điểm và lễ tân",
        steps: ['Mở "Theo khách", gõ tên khách hoặc tên thợ để biết ekip đang ở set nào.'],
        troubles: ["Trang này chỉ để xem: thợ chụp, Trợ lý Studio và ca trưởng mới chọn set cho khách."],
      },
      {
        for: ["lead", "exec"],
        title: "Việc của quản lý trực tiếp và ca trưởng",
        steps: [
          'Chọn đúng cơ sở ở ô đầu trang, rồi khai set một lần ở "Sắp xếp sơ đồ": thêm tầng, thêm set, bấm "Lưu sơ đồ". Khai xong là dùng được, máy tự xếp vị trí. Cơ sở nào muốn dùng thì tự khai, không phải chờ đợt nào.',
          'Muốn sát thực tế: ở "Sắp xếp sơ đồ" bấm "Sắp xếp vị trí", nhập rộng và sâu của tầng theo mét, kéo set đến đúng chỗ. Trên điện thoại nhập bằng ô số. Hai set đè nhau thì chưa lưu được.',
          'Gắn concept cho set ở "Sắp xếp sơ đồ", nút "Concept" trên từng dòng set, để máy gợi ý đúng set cho thợ. Không gắn cũng dùng được, chỉ là không có gợi ý.',
          'Cơ sở có khách ảnh thẻ: bấm "Khai Góc ảnh thẻ" ở tầng đặt góc đó. Mỗi cơ sở một góc.',
          "Ca trưởng bấm hộ khi thợ quên: chọn set, chụp xong, dọn set đều được.",
          'Set hỏng: bấm vào ô, bấm "Tạm đóng". Sửa xong bấm "Mở lại".',
          'Cuối ca xem khung "Đơn lệch set": hỏi lại ekip của đơn, bấm "Bổ sung set", chọn concept còn thiếu rồi chọn set đã chụp, bấm "Lưu". Đơn nào thiếu nhiều concept thì bổ sung từng concept một.',
          'Chọn nhầm set khi bổ sung: mở khung "Đã bổ sung", bấm "Gỡ" ở dòng đó rồi bổ sung lại.',
          "Nhận tin chuông đơn lệch buổi tối: bấm tin để mở đúng bảng ngày hôm đó, bổ sung như trên.",
        ],
        troubles: [
          "Bổ sung báo concept đã được bổ sung rồi → mở khung \"Đã bổ sung\" xem lượt cũ, chọn nhầm thì bấm \"Gỡ\" trước.",
          "Ô \"Set đã có khách thật\" thấp hơn thực tế → thợ chưa bấm chọn set cho khách; nhắc ekip bấm ngay lúc vào set.",
          "Không bỏ được set → set đang có khách, chụp xong mới bỏ được.",
          "Lưu sơ đồ báo có người vừa sửa → tải lại trang rồi sửa tiếp.",
          'Nút "Lưu sơ đồ" xám, báo set nằm ngoài mặt sàn → tầng đã kín chỗ: bấm vào set đó trên mặt bằng, dời vào chỗ trống hoặc nới ô "Sâu" của tầng.',
          "Dữ liệu trang này không dùng để chấm điểm hay tính lương.",
        ],
      },
    ],
  },
};
